import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute(
    '/_app/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId',
)({
    head: () => ({
        meta: [{ title: 'Caregiver SMS Shadow | Phoebe Admin' }],
    }),
    validateSearch: z.object({
        organizationId: z.string().optional(),
        mode: z.enum(['live', 'sandbox']).default('live'),
    }),
});
